import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const AccountsReportToolbarContext = createContext(null);

export function AccountsReportToolbarProvider({ children }) {
  const [endAction, setEndAction] = useState(null);
  const setTabEndAction = useCallback((node) => {
    setEndAction(node);
  }, []);

  const value = useMemo(
    () => ({
      endAction,
      setTabEndAction
    }),
    [endAction, setTabEndAction]
  );

  return (
    <AccountsReportToolbarContext.Provider value={value}>{children}</AccountsReportToolbarContext.Provider>
  );
}

export function useAccountsReportToolbar() {
  const ctx = useContext(AccountsReportToolbarContext);
  if (!ctx) {
    throw new Error('useAccountsReportToolbar must be used within AccountsReportToolbarProvider');
  }
  return ctx;
}
